class CountrySelector extends HTMLElement {
    constructor() {
        super();
        this.bindEvents();
    }

    bindEvents() {
        const button = this.querySelector(".country__selector-current");
        button?.addEventListener("click",  this.toggleDropdown.bind(this))
    }

    toggleDropdown() {
        this.classList.toggle("open");
    }
}

customElements.define("country-selector", CountrySelector);